/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, css, Fade, Grid, Typography } from '@mui/material';
import ghostIcon from 'assets/ghostIcon.svg';
import { useTelegramUser } from 'hooks/useTelegramUser';
import { TXT_BACK, TXT_ERROR } from 'translations';
import { ROUTES } from 'utils/routes';

const MenuError: FC = () => {
  const { t } = useTranslation();
  const { id: userId } = useTelegramUser();

  return (
    <Fade in>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        justifyContent="center"
        alignItems="center"
        css={css`
          height: calc(100vh - 112px);
        `}
      >
        <Grid item>
          <Grid container direction="column" alignItems="center" spacing={4}>
            <Grid item>
              <Box textAlign="center">
                <img src={ghostIcon} width={80} height={80} alt="ghost" />
              </Box>
            </Grid>

            <Grid item>
              <Typography
                css={css`
                  text-align: center;
                `}
              >
                {t(TXT_ERROR)}
              </Typography>
            </Grid>

            <Grid item>
              <Button
                component={Link}
                to={generatePath(ROUTES.WEEK, { userId: `${userId}` })}
                variant="contained"
                startIcon={<ArrowBackIosNewIcon />}
              >
                {t(TXT_BACK)}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default MenuError;
